import { Timestamped } from '../timestamped';
import { z } from 'zod';

export const DsiIssueType = z.enum(['wrongQuantity', 'diffProduct', 'notScanned', 'removed']);
export type DsiIssueType = z.infer<typeof DsiIssueType>;

export const DsiIssueProduct = z.object({
    itemId: z.string(),
    rootItemId: z.string(),
    name: z.string(),
    brand: z.string().nullish(),
    flags: z.string().array().nullish(),
    cgId: z.string().nullish(),
    cgIcon: z.string().nullish(),
    capacity: z.number().nullish(),
    gtin: z.string().nullish(),
});
export type DsiIssueProduct = z.infer<typeof DsiIssueProduct>;

export const DsiIssueCommodityGroup = z.object({
    groupId: z.string(),
    name: z.string(),
    rawName: z.string(),
    icon: z.string().nullish(),
});
export type DsiIssueCommodityGroup = z.infer<typeof DsiIssueCommodityGroup>;

export const DsiIssueDraft = z.object({
    issueGuid: z.string(),
    event: z.string(),
    type: DsiIssueType,
    scannedAtRegister: z.boolean().nullish(),

    originalProduct: DsiIssueProduct.nullish(),
    product: DsiIssueProduct.nullish(),
    commodityGroup: DsiIssueCommodityGroup.nullish(),
    text: z.string().nullish(),
    price: z.number().nullish(),
    amount: z.number().nullish(),
});
export type DsiIssueDraft = z.infer<typeof DsiIssueDraft>;

export const DsiIssue = Timestamped.and(DsiIssueDraft);
export type DsiIssue = z.infer<typeof DsiIssue>;
